var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M13.985 5.126h5.956v10.571h-7.444l-.397-2.084H6.144v7.395H4.06V2.992h9.529z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }